import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form/immutable';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Link } from 'react-router-dom';
import Button from '../../../ui/Button';
import { updateOrder } from '../../order/order';
import Form from '../../../ui/Form';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Input from '../../../ui/Input';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from '../../../ui/Select';
import styles from './css/Address.scss';
import Alert from "../../../ui/Alert";
import {getLocations} from "../locations";

/* eslint-disable react/prop-types, react/no-multi-comp */
const renderField = allProps => {

    /* eslint no-unused-vars: ["off", { "ignoreRestSiblings": true }] */
    const { size, ...props } = allProps;

    props.input.id = (props.id || props.input.name);

    return (
        <Form.Control erroneous={!!props.error}>
            {props.label !== false && (
                <Form.Label htmlFor={props.input.name} required={props.required}>
                    <FormattedMessage
                        id={`frontend.form_selector_shipping.label.${props.label || props.input.name}`}
                    />
                </Form.Label>
            )}
            <Input {...props.input} type={props.type}/>
            {props.hint && (
                <Form.Hint>
                    <FormattedMessage id={props.hint} />
                </Form.Hint>
            )}
            {props.error && (
                <Form.Error>
                    {props.error}
                </Form.Error>
            )}
        </Form.Control>
    );
};

const renderSelect = props => {
    return (
        <Form.Control erroneous={!!props.error}>
            {props.label !== false && (
                <Form.Label htmlFor={props.input.name} required={props.required}>
                    <FormattedMessage
                        id={`frontend.form_selector_shipping.label.${props.label || props.input.name}`}
                    />
                </Form.Label>
            )}
            <Select {...props.input} disabled={props.disabled}>
                {props.children}
            </Select>
            {props.hint && (
                <Form.Hint>
                    <FormattedMessage id={props.hint} />
                </Form.Hint>
            )}
            {props.error && (
                <Form.Error>
                    {props.error}
                </Form.Error>
            )}
        </Form.Control>
    );
};

@injectIntl
export class CreateAddressForm extends Component {
/* eslint-enable */
    static propTypes = {
        addressbooks: ImmutablePropTypes.map,
        dispatch: PropTypes.func.isRequired,
        order: ImmutablePropTypes.map,
        expandBilling: PropTypes.bool,
        handleSubmit: PropTypes.func,
        initialValues: ImmutablePropTypes.map,
        intl: intlShape,
        regions: ImmutablePropTypes.map,
        submitting: PropTypes.bool,
    }

    componentWillMount() {
        window.scrollTo(0, 0);
    }

    showAddressBook() {
        const { order, dispatch } = this.props;
        // if (steps.getIn(['shipping', 'active'])) {
        const newOrder = order.set('shipToNewAddress', false);
        dispatch(updateOrder(newOrder));
        // }
    }

    render() {
        const { expandBilling, initialValues, handleSubmit, validationData, dispatch, order } = this.props;
        const { formatMessage } = this.props.intl;

        const selectedOrderRegion = this.props.orderState.get('region');

        const submitFailed = validationData.getIn(['address', 'create', 'submitFailed']);
        const submitErrors = validationData.getIn(['address', 'create', 'submitErrors']);
        const error = validationData.getIn(['address', 'create', 'error']);

        const shipToNewAddress = order ? order.get('shipToNewAddress') : false;
        const addressbooks = (this.props.addressbooks || Immutable.Map());
        const regions = (this.props.regions || Immutable.Map())
            .map(region => (
                Immutable.Map({ id: region.get('id'), alias: formatMessage({id: region.get('alias')}) })
            ))
            .sortBy(region => region.get('alias'));

        const shouldLockRegion = initialValues && !!initialValues.getIn(['address', 'region']);

        return (
            <div>
                { submitFailed ?
                    (<Alert type='warning'>
                        <FormattedMessage
                            id={"frontend.addressbook.error." + error }/>
                    </Alert>) : null }
                <br />
                <Form onSubmit={handleSubmit} noValidate>
                    {/* Addressbook */}
                    <Form.Row>
                        <Field
                            name='addressbook'
                            component={renderSelect}
                            label={false}
                            error={submitErrors && submitErrors.getIn(['addressbook'])}
                            required
                        >
                            <option>
                                {formatMessage({
                                    id: 'frontend.form_selector_addressbook.select.option.addressbook',
                                })}
                            </option>
                            {addressbooks.sort((a, b) => {
                                if (a.get('type') === 'addressbook.personal') return -1;
                                if (b.get('type') === 'addressbook.personal') return 1;
                                return 0;
                            }).map(addressbook => (
                                addressbook.get('type') === 'addressbook.personal' ? (
                                    <option key={addressbook.get('id')} value={addressbook.get('id')}>
                                        {formatMessage({id: 'frontend.form_selector_addressbook.select.option.personal_addressbook'})}
                                    </option>
                                ) : (
                                    <option key={addressbook.get('id')} value={addressbook.get('id')}>
                                        {addressbook.get('name')}
                                    </option>
                                )
                            )).toArray()}
                        </Field>
                    </Form.Row>

                    {/* Contact */}
                    <Form.Fieldset>
                        <h3>
                            <FormattedMessage
                                id='frontend.form_selector_shipping.headline.address'
                            />
                        </h3>
                        <Form.Row>
                            <Field
                                component={renderField}
                                hint='frontend.form_selector_shipping.hint.organization'
                                label='organization'
                                name='address.organization'
                                type='text'
                                error={submitErrors && submitErrors.getIn(['address','organization'])}
                            />
                        </Form.Row>
                        <Form.Row>
                            <Field
                                component={renderField}
                                hint='frontend.form_selector_shipping.hint.phone'
                                label='phone'
                                name='address.phone'
                                required
                                type='text'
                                error={submitErrors && submitErrors.getIn(['address','phone'])}
                            />
                        </Form.Row>
                        <Form.Row>
                            <Field
                                component={renderField}
                                label='email'
                                name='address.email'
                                required
                                type='email'
                                error={submitErrors && submitErrors.getIn(['address','email'])}
                            />
                        </Form.Row>
                        <Form.Row>
                            <Field
                                component={renderField}
                                label='street'
                                name='address.street'
                                required
                                type='text'
                                error={submitErrors && submitErrors.getIn(['address','street'])}
                            />
                        </Form.Row>
                        <Form.Row width={25}>
                            <Field
                                component={renderField}
                                label='zip'
                                name='address.zip'
                                required
                                type='text'
                                size={10}
                                error={submitErrors && submitErrors.getIn(['address','zip'])}
                            />
                        </Form.Row>
                        <Form.Row>
                            <Field
                                component={renderField}
                                label='city'
                                name='address.city'
                                required
                                type='text'
                                error={submitErrors && submitErrors.getIn(['address','city'])}
                            />
                        </Form.Row>
                        <Form.Row>
                            <Field
                                component={renderSelect}
                                disabled={selectedOrderRegion ? true : false}
                                label='region'
                                name='address.region'
                                error={submitErrors && submitErrors.getIn(['address','region'])}
                                required
                            >
                                <option>
                                    {formatMessage({
                                        id: 'frontend.form_selector_shipping.select.option.region_selector',
                                    })}
                                </option>
                                {regions.map(region => (
                                    <option key={region.get('id')} value={region.get('id')}>
                                        {region.get('alias')}
                                    </option>
                                )).toArray()}
                            </Field>
                            { shipToNewAddress ?
                                (<Form.Hint>
                                    <FormattedMessage
                                        id='frontend.form_selector_shipping.hint.country'
                                    />
                                    {' '}
                                    <Link to='/order'>
                                        <FormattedMessage
                                            id='frontend.form_selector_shipping.hint.country_addendum'
                                        />
                                    </Link>
                                </Form.Hint>)
                                : null}
                        </Form.Row>
                    </Form.Fieldset>

                    {/* Location */}
                    <Form.Fieldset>
                        <h3>
                            <FormattedMessage
                                id='frontend.form_selector_shipping.headline.address_details'
                            />
                        </h3>
                        <Form.Row>
                            <Field
                                component={renderField}
                                hint='frontend.form_selector_shipping.hint.location.old_number'
                                label='location.old_number'
                                name='oldNumber'
                                type='text'
                                error={submitErrors && submitErrors.getIn(['oldNumber'])}
                            />
                        </Form.Row>
                        <Form.Row>
                            <Field
                                name='contact'
                                component={renderField}
                                type='text'
                                required
                                hint='frontend.form_selector_shipping.hint.location.contact'
                                error={submitErrors && submitErrors.getIn(['contact'])}
                            />
                        </Form.Row>
                        <Form.Row>
                            <Field
                                name='building'
                                component={renderField}
                                type='text'
                                error={submitErrors && submitErrors.getIn(['building'])}
                            />
                        </Form.Row>
                        <Form.Row>
                            <Field
                                name='address.floor'
                                component={renderField}
                                type='text'
                                error={submitErrors && submitErrors.getIn(['address', 'floor'])}
                            />
                        </Form.Row>
                        <Form.Row>
                            <Field
                                name='info'
                                component={renderField}
                                type='text'
                                required
                                hint='frontend.form_selector_shipping.hint.location.info'
                                label='location.info'
                                error={submitErrors && submitErrors.getIn(['info'])}
                            />
                        </Form.Row>
                        <Form.Row>
                            <Field
                                name='taxNumber'
                                component={renderField}
                                type='text'
                                label='location.tax_number'
                                error={submitErrors && submitErrors.getIn(['taxNumber'])}
                            />
                        </Form.Row>
                        <Form.Row>
                            <Field
                                name='costCenter'
                                component={renderField}
                                type='text'
                                label='location.cost_center'
                                error={submitErrors && submitErrors.getIn(['costCenter'])}
                            />
                        </Form.Row>
                    </Form.Fieldset>

                    {/* Billing */}
                    <Form.Fieldset>

                        <h3>
                            <Field
                                component='input'
                                id='billing.enable'
                                name='billing.enable'
                                type='checkbox'
                                error={submitErrors && submitErrors.getIn(['billing','enable'])}
                            />
                            {' '}
                            <label htmlFor='billing.enable'>
                                <FormattedMessage
                                    id='frontend.form_selector_shipping.headline.billing_address'
                                />
                            </label>
                        </h3>

                        {/* Billing */}
                        <div className={styles[expandBilling ? 'billingSectionEnabled' : 'billingSection']}>
                            <Form.Row>
                                <Field
                                    name='billing.address.contact'
                                    label='contact'
                                    component={renderField}
                                    type='text'
                                    required={expandBilling}
                                    error={submitErrors && submitErrors.getIn(['billing','address','contact'])}
                                />
                            </Form.Row>
                            <Form.Row>
                                <Field
                                    name='billing.address.organization'
                                    label='organization'
                                    component={renderField}
                                    type='text'
                                    required={expandBilling}
                                    hint='frontend.form_selector_shipping.hint.organization'
                                    error={submitErrors && submitErrors.getIn(['billing','address','organization'])}
                                />
                            </Form.Row>
                            <Form.Row>
                                <Field
                                    name='billing.address.phone'
                                    label='phone'
                                    component={renderField}
                                    type='text'
                                    required={expandBilling}
                                    hint='frontend.form_selector_shipping.hint.phone'
                                    error={submitErrors && submitErrors.getIn(['billing','address','phone'])}
                                />
                            </Form.Row>
                            <Form.Row>
                                <Field
                                    name='billing.address.email'
                                    label='email'
                                    component={renderField}
                                    type='text'
                                    required={expandBilling}
                                    error={submitErrors && submitErrors.getIn(['billing','address','email'])}
                                />
                            </Form.Row>
                            <Form.Row>
                                <Field
                                    name='billing.address.street'
                                    label='street'
                                    component={renderField}
                                    type='text'
                                    required={expandBilling}
                                    error={submitErrors && submitErrors.getIn(['billing','address','street'])}
                                />
                            </Form.Row>
                            <Form.Row>
                                <Field
                                    name='billing.address.zip'
                                    label='zip'
                                    component={renderField}
                                    type='text'
                                    required={expandBilling}
                                    size='4'
                                    error={submitErrors && submitErrors.getIn(['billing','address','zip'])}
                                />
                            </Form.Row>
                            <Form.Row>
                                <Field
                                    name='billing.address.city'
                                    label='city'
                                    component={renderField}
                                    type='text'
                                    required={expandBilling}
                                    size='8'
                                    error={submitErrors && submitErrors.getIn(['billing','address','city'])}
                                />
                            </Form.Row>
                            <Form.Row>
                                <Field
                                    name='billing.address.region'
                                    component={renderSelect}
                                    error={submitErrors && submitErrors.getIn(['billing','address','region'])}
                                    label='region'
                                    required
                                >
                                    <option>
                                        {formatMessage({
                                            id: 'frontend.form_selector_shipping.select.option.region_selector',
                                        })}
                                    </option>
                                    {regions.map(region => (
                                        <option key={region.get('id')} value={region.get('id')}>
                                            {region.get('alias')}
                                        </option>
                                    )).toArray()}
                                </Field>
                            </Form.Row>
                        </div>
                    </Form.Fieldset>

                    <Button emphasis='primary' type='submit' block>
                        { shipToNewAddress ?
                            (<FormattedMessage id='frontend.form_selector_shipping.button.save_and_continue' />)
                            : (<FormattedMessage id='frontend.form_selector_shipping.button.save' />)}
                    </Button>
                </Form>
                { shipToNewAddress ?
                    (<div>
                        <br />
                        <Button
                            block
                            onClick={this.showAddressBook.bind(this)}
                        >
                            <FormattedMessage id='frontend.form_selector_shipping.button.cancel' />
                        </Button>
                    </div>)
                    :
                    <div>
                        <br />
                        <Button link to='/addressbook' block>
                            <FormattedMessage id='frontend.form_selector_shipping.button.cancel' />
                        </Button>
                    </div>}
            </div>
        );
    }
}

let FormComponent = reduxForm({
    form: 'address.create',
})(CreateAddressForm);

const selector = formValueSelector('address.create');
FormComponent = connect(state => ({
    validationData: state.form,
    orderState: state.order,
    currentStep: state.steps,
    expandBilling: Boolean(selector(state, 'billing.enable')),
}))(FormComponent);

// See https://github.com/erikras/redux-form/issues/1010
export default {
    Component: FormComponent,
};
